module.exports = __webpack_public_path__ + "img/logo.ccd09a89.png";